import React, { useState, useEffect } from 'react';
import { BrandLogosStyles } from './BrandLogos.styled';
import { tablet_portrait_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import useWindowResize from 'pubweb-smokey/dist/hooks/useWindowResize';

import BrandLogosDesktop from './images/brand-logos-desktop.svg';
import BrandLogosMobile from './images/brand-logos-mobile.svg';

const BrandLogos = () => {
  const [isMobileLayout, setIsMobileLayout] = useState(true);

  useWindowResize(() => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth >= tablet_portrait_breakpoint) {
        setIsMobileLayout(false); // desktop
      } else {
        setIsMobileLayout(true); // mobile
      }
    }
  }, [tablet_portrait_breakpoint]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth >= tablet_portrait_breakpoint) {
        setIsMobileLayout(false); // desktop
      } else {
        setIsMobileLayout(true); // mobile
      }
    }
  }, []);

  return (
    <BrandLogosStyles>
      <div className="brand-logos-container">
        {isMobileLayout ? (
          <div className="brand-logos-mobile">
            <BrandLogosMobile />
          </div>
        ) : (
          <div className="brand-logos-desktop">
            <BrandLogosDesktop />
          </div>
        )}
      </div>
    </BrandLogosStyles>
  );
};

export default BrandLogos;
